import { TRANSACTION_TYPES } from '../utils/constants';

const vulnerabilitiesRoutes = [
    {
        path: '/vulnerabilities',
        name: 'VulnerabilitiesPage',
        component: () => import('../views/vulnerabilities/VulnerabilitiesComponent.vue'),
        meta: {
            requiresAuth: true,
            permission: 'vulnerabilities',
            module: 'risksManagement',
            planFeature: 'custom_catalogs',


        }

    },
    {
        path: '/vulnerabilities/create',
        name: 'VulnerabilityCreatePage',
        component: () => import('../views/vulnerabilities/VulnerabilitiesManagerComponent.vue'),
        props: { type: TRANSACTION_TYPES.CREATE },
        meta: {
            requiresAuth: true,
            permission: ['vulnerabilities', 'createVulnerability'],
            module: 'risksManagement',


        }

    },
    {
        path: '/vulnerabilities/edit/:vulnerabilityId',
        name: 'VulnerabilitiesEditPage',
        component: () => import('../views/vulnerabilities/VulnerabilitiesManagerComponent.vue'),
        props: route => ({ type: TRANSACTION_TYPES.EDIT, vulnerabilityId: route.params.vulnerabilityId }),
        meta: {
            requiresAuth: true,
            permission: ['vulnerabilities', 'editVulnerability'],
            module: 'risksManagement',

        }

    },
    {
        path: '/vulnerabilities/show/:vulnerabilityId',
        name: 'VulnerabilitiesShowPage',
        component: () => import('../views/vulnerabilities/VulnerabilitiesManagerComponent.vue'),
        props: route => ({ type: TRANSACTION_TYPES.SHOW, vulnerabilityId: route.params.vulnerabilityId }),
        meta: {
            requiresAuth: true,
            permission: ['vulnerabilities', 'viewVulnerability'],
            module: 'risksManagement',

        }

    },
];

export default vulnerabilitiesRoutes;